import { render, staticRenderFns } from "./ChatSelectedWrapper.vue?vue&type=template&id=197c1f3d&scoped=true&lang=pug&"
import script from "./ChatSelectedWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatSelectedWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c1f3d",
  null
  
)

export default component.exports